import {Typography} from "@mui/material";
import {AccountTree, Preview, RateReview, RocketLaunch} from "@mui/icons-material";
import React from "react";
import styled from "styled-components";
import {useMediaQuery} from "react-responsive";
import {PROCESS_STEPS} from "content/facts";
import {SITE} from "site";

const STEP_ICONS = [AccountTree, Preview, RateReview, RocketLaunch];

export default function HowIWork() {
    const isTabletOrMobile = useMediaQuery({query: "(max-width: 1224px)"});
    const isShort = useMediaQuery({query: "(max-height: 820px)"});
    return (
        <Root $stack={isTabletOrMobile} aria-labelledby="how-i-work-heading">
            <Typography
                id="how-i-work-heading"
                component="h2"
                style={{
                    fontSize: "16px",
                    marginBottom: "0.25em",
                }}
            >
                <u>How I work with agents</u>
            </Typography>
            {(isTabletOrMobile || !isShort) && (
                <Typography style={{fontSize: isTabletOrMobile ? "13px" : "14px", color: "#e8e8e8"}}>
                    Agents are extra hands on a review-gated process, not a bypass.
                </Typography>
            )}

            <Steps $compact={isTabletOrMobile}>
                {PROCESS_STEPS.map((step, index) => {
                    const Icon = STEP_ICONS[index];
                    return (
                        <Step key={step.title}>
                            <StepHead>
                                <Icon fontSize="small" aria-hidden="true" />
                                <Typography style={{fontSize: "14px", fontWeight: 600}}>
                                    {index + 1}. {step.title}
                                </Typography>
                            </StepHead>
                            <Typography style={{fontSize: "13px", color: "#e8e8e8"}}>
                                {step.body}
                            </Typography>
                        </Step>
                    );
                })}
            </Steps>

            {!isShort && (
                <Typography style={{fontSize: "13px", color: "#e0e0e0", marginTop: "0.5em"}}>
                    Machine-readable facts:{" "}
                    <a href={SITE.llmsPath}>
                        {SITE.llmsPath}
                    </a>
                    {" · "}
                    <a href={SITE.aboutJsonPath}>
                        {SITE.aboutJsonPath}
                    </a>
                </Typography>
            )}
        </Root>
    );
}

const Root = styled.section<{ $stack: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.$stack ? "4px" : "0")};
  padding-top: ${(props) => (props.$stack ? "8px" : "0")};
  border-top: ${(props) => (props.$stack ? "2px solid #8a8a8a" : "none")};
  line-height: 1.35;
  min-height: 0;
  min-width: 0;
`;

const Steps = styled.ol<{ $compact: boolean }>`
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$compact ? "10px" : "8px")};
`;

const Step = styled.li`
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;

  p {
    overflow-wrap: anywhere;
  }
`;

const StepHead = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
